// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"54":"52adf3bc","85":"8641421e","988":"cfa0792f"}[chunkId] + ".js";
};